// eslint-disable react/jsx-pascal-case
import React, { ChangeEvent } from 'react'

import { UUID } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { mainColors, semanticColors } from '../../styles/colors'
import { ToggleField } from '../ToggleField'
import { ToggleBooleanType } from '../ToggleField/ToggleField.types'
import * as S from './BooleanField.styles'

interface BooleanFieldProps {
  id: UUID
  value: string | boolean
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  mode: 'read' | 'write'
}

export const BooleanField = ({ value, onChange, id, mode }: BooleanFieldProps) => {
  const bg = value ? mainColors.accentExtremelyLight : semanticColors.failureExtraLight
  const isString = typeof value === 'string'
  const color = value ? mainColors.accentMedium : semanticColors.failureMedium

  if (mode === 'read') {
    return (
      <S.BooleanTag bg={bg} color={color}>
        {value ? 'Yes' : 'No'}
      </S.BooleanTag>
    )
  }

  return (
    <ToggleField>
      <ToggleField.Option
        label={id}
        onChange={onChange}
        value
        checked={value === (isString ? 'true' : true)}
        id={`${id}-yes`}
        title="Yes"
      />
      <ToggleField.Option
        label={id}
        onChange={onChange}
        value={false}
        checked={value === (isString ? 'false' : false)}
        id={`${id}-no`}
        toggleType={ToggleBooleanType.false}
        title="No"
      />
    </ToggleField>
  )
}
